"use strict";
/**
 * DynamoDB-related type definitions
 * Single Table Design patterns
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=dynamodb.js.map